import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useReadKeysQuery = (readKey: string | null) => {
    const { keys } = useAvApi();

    return useQuery({
        enabled: !!readKey,
        queryKey: ['keys'],
        refetchInterval: 1000,
        queryFn: async () => {
            if (!readKey) return;

            const { data } = await keys.getKeysByReadKey({ readKey });

            return data;
        },
        gcTime: 0,
        staleTime: 0,
    });
};
